/** Playbook Confidence Badge — displays "ABM ✓ / Jamf ✓ / AppleCare+ ✓"
 *  compact chips summarising which customer-standard fields are honoured
 *  by a given plan / row.  Reads from customer_standard (Concierge plans)
 *  or inherited_fields (Bulk Deployment). */
import { CheckCircle2, AlertCircle, HelpCircle } from "lucide-react";

export default function PlaybookConfidenceBadge({ standard = {}, testId = "playbook-confidence" }) {
  if (!standard || Object.keys(standard).length === 0) return null;
  const chips = [
    { key: "apple_abm", label: "ABM", value: standard.apple_abm },
    { key: "apple_mdm", label: (standard.apple_mdm || "MDM").replace("_", " "), value: standard.apple_mdm },
    { key: "applecare_plus", label: "AppleCare+", value: standard.applecare_plus },
    { key: "windows_autopilot", label: "Autopilot", value: standard.windows_autopilot },
    { key: "reuse_policy", label: "Reuse", value: standard.reuse_policy },
    { key: "erasure_required", label: "Erasure", value: standard.erasure_required },
    { key: "zero_touch", label: "Zero-touch", value: standard.zero_touch },
  ].filter((c) => c.value);
  if (!chips.length) return null;
  return (
    <div className="flex flex-wrap gap-1.5 items-center" data-testid={testId}>
      <span className="text-[10px] uppercase tracking-wider text-[color:var(--st-text-subtle)]">Playbook</span>
      {chips.map((c) => {
        const ok = ["yes", "allowed", "true", true].includes(c.value) || (typeof c.value === "string" && c.value.startsWith("jamf")) || (typeof c.value === "string" && c.value === "intune");
        const unknown = c.value === "unknown";
        const Icon = ok ? CheckCircle2 : unknown ? HelpCircle : AlertCircle;
        const cls = ok ? "bg-emerald-50 text-emerald-700 border-emerald-200"
                   : unknown ? "bg-slate-50 text-slate-500 border-slate-200"
                   : "bg-amber-50 text-amber-700 border-amber-200";
        return (
          <span key={c.key} className={`inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-[10px] border ${cls}`}
                data-testid={`${testId}-${c.key}`} title={`${c.label}: ${c.value}`}>
            <Icon className="h-2.5 w-2.5" strokeWidth={2} /> {c.label}
          </span>
        );
      })}
    </div>
  );
}
